import { render, staticRenderFns } from "./goodsDetailView.vue?vue&type=template&id=a52d0a00&"
import script from "./goodsDetailView.vue?vue&type=script&lang=js&"
export * from "./goodsDetailView.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetailView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports